<template>
  <div>
    <div class="layer-item">
      <span
        class="oi oi-resize-height handle mr-2 pb-1 text-primary"
        title="Przytrzymaj aby przenieść warstwę."
      ></span>
      <a
        href="#"
        class="action layer-expander"
        v-bind:title="layer.expanded ? 'Ukryj szczegóły' : 'Pokaż szczegóły'"
        @click="layer.expanded = !layer.expanded"
      >
        <span v-if="layer.expanded" class="oi oi-minus"></span>
        <span v-else class="oi oi-plus"></span>
      </a>
      <b-form-checkbox
        :checked="layer.visible"
        @change="toggleVisible"
        class="mr-0"
        style="margin-top: -2px;"
      ></b-form-checkbox>
      <span class="layer-name">
        {{ layer.title }}
      </span>
      <a
        href="#"
        v-if="isVectorLayer && layer.isSystem"
        v-bind:class="layer.active ? 'text-success' : ''"
        v-bind:title="
          layer.active ? 'Oznacz jako nieaktywną' : 'Oznacz jako aktywną'
        "
        @click.prevent="toggleActive()"
        class="action layers-icon d-inline-block d-lg-inline-block d-xl-inline-block"
      >
        <span class="oi oi-power-standby"></span>
      </a>
      <a
        href="#"
        title="Odczytywanie informacji. Kliknij aby wyłączyć."
        @click="enableGetFeatureInfo(null)"
        v-if="layer === getFeatureSelectedLayer && !hideDetails"
      >
        <icon name="info" class="text-success"></icon>
      </a>
      <a
        href="#"
        title="Odczytywanie informacji. Kliknij aby włączyć."
        @click="enableGetFeatureInfo(layer)"
        v-else-if="layer.getFeatureInfoEnabled && !hideDetails"
      >
        <icon name="info"></icon>
      </a>
      <b-dropdown
        no-caret
        title="Ustawienia"
        class="action"
        tabindex="0"
        right
        dropup
      >
        <template slot="button-content">
          <span class="oi oi-cog layers-icon"></span>
        </template>
        <div class="scrollable-menu">
          <b-dropdown-header v-if="isVectorLayer">Styl</b-dropdown-header>
          <b-dropdown-item
            v-if="isVectorLayer"
            v-for="style in styles"
            class="layer-style"
            :key="style.id"
            @click="setStyle(style.id)"
          >
            {{ style.domyslny ? 'Styl domyślny' : 'Styl ' + style.index }}
            <span
              class="oi oi-circle-check text-success float-right"
              v-if="style.id === layer.styleId"
            ></span>
            <span
              class="oi oi-circle-x text-danger float-right remove-style"
              title="Usuń"
              @click.stop="removeStyle(style.id)"
              v-if="style.id !== layer.styleId && !style.domyslny"
            ></span>
          </b-dropdown-item>
          <b-dropdown-item-button
            v-if="isVectorLayer && !readOnly"
            @click="createStyle"
            class="font-weight-bold d-none d-lg-block d-xl-block"
            >Utwórz styl</b-dropdown-item-button
          >
          <b-dropdown-divider v-if="layer.isDtm"></b-dropdown-divider>
          <b-dropdown-item v-if="layer.isDtm" @click="toggle3dView">
            2D
            <icon name="check" class="text-success" v-if="!layer.view3d" />
          </b-dropdown-item>
          <b-dropdown-item v-if="layer.isDtm" @click="toggle3dView">
            3D
            <icon name="check" class="text-success" v-if="layer.view3d" />
          </b-dropdown-item>
          <b-dropdown-divider
            v-if="!layer.isSystem && !layer.isAdministrative"
          ></b-dropdown-divider>
          <b-dropdown-item-button
            v-if="!layer.isSystem && !layer.isAdministrative && !readOnly"
            @click="remove"
            >Usuń warstwę</b-dropdown-item-button
          >
          <b-dropdown-divider
            v-if="!layer.isAdministrative || isVectorLayer || layer.isDtm"
          ></b-dropdown-divider>
          <b-dropdown-item @click="zoomToTheLayersRange(layer)"
            >Przybliż do zasięgu warstwy</b-dropdown-item
          >
          <b-dropdown-item
            v-if="isDrogiStawkiJst"
            @click="genereteRateRaport(layer)"
            >Generuj raport ze stawek za zajęcie pasa drogowego</b-dropdown-item
          >
        </div>
      </b-dropdown>
    </div>
    <div class="layer-legend" v-show="layer.expanded">
      <img
        v-if="legends.length"
        v-for="legend in legends"
        :key="legend"
        :src="legend"
        :alt="layerLegendErrorMessage"
      />
      <p class="mb-0" v-if="legendAlt">{{ legendAlt }}</p>
    </div>
  </div>
</template>

<script>
import { LayerTypes } from '../common/layerEnums';
import {
  WINDOW_API_ERROR_SHOW,
  WINDOW_NOTIFICATION_SHOW
} from '../store/mutations.type';
import { mapGetters } from 'vuex';
import SettingsInstance from '../api/SettingsInstance';
import { SET_GET_FEATURE_INFO_LAYER } from '../store/actions.type';
import { Api as ApiStawki } from '../api/api-stawki.js';

export default {
  name: 'Layer',
  data() {
    return {
      legendAlt: null
    };
  },
  props: {
    layer: Object,
    isLast: Boolean,
    isFirst: Boolean
  },
  computed: {
    ...mapGetters(['readOnly', 'getFeatureSelectedLayer']),
    legends() {
      if (this.layer.type !== LayerTypes.wms && !this.layer.isSystem) {
        this.legendAlt =
          'Warstwa musi być powiązana z usługą WMS, aby było możliwe wyświetlenie legendy.';
        return [];
      }

      if (this.layer.isSystem) {
        return [];
        return [
          SettingsInstance.geoserverUrl +
            `/pit/wms?REQUEST=GetLegendGraphic&VERSION=1.3&FORMAT=image%2Fpng&LAYER=${this.layer.datasource}`
        ];
      } else {
        return [];
        if (this.layer.url) {
          const legendQueryPrefix = this.layer.url.includes('?') ? '&' : '?';

          let legendUrl =
            this.layer.url +
            `${legendQueryPrefix}REQUEST=GetLegendGraphic` +
            '&VERSION=1.1.1' +
            '&SERVICE=WMS' +
            '&FORMAT=' +
            encodeURIComponent('image/png');

          return this.layer.names.map(x => {
            return legendUrl + '&LAYER=' + encodeURIComponent(x);
          });
        } else {
          this.legendAlt =
            'Wyświetlenie legendy jest niemożliwe. Warstwa nie posiada adresu powiązanej usługi.';
          return [];
        }
      }
    },
    isVectorLayer() {
      let rasterLayers = [LayerTypes.wms, LayerTypes.wmts, LayerTypes.wcs];

      return rasterLayers.indexOf(this.layer.type) < 0;
    },
    styles() {
      let layer = this.layer;

      return this.$store.getters.styles
        .filter(x => x.id_warstwy === layer.id)
        .sort((a, b) => {
          if (a.domyslny) {
            return -1;
          } else if (b.domyslny) {
            return 1;
          } else {
            return a.index - b.index;
          }
        });
    },
    styleId() {
      return (this.layer || {}).styleId;
    },
    isDrogiStawkiJst() {
      return (
        this.layer.names && this.layer.names.includes('pit:drogi_stawki_jst')
      );
    },
    layerLegendErrorMessage() {
      return this.contextIsAnonymous
        ? 'Brak uprawnień do pobrania legendy.'
        : 'Błąd usługi udostępniającej legendę.';
    },
    hideDetails() {
      return (
        this.layer.names[0].includes('milestones') ||
        this.layer.names[0].includes('ot_skjz_l')
      );
    }
  },
  methods: {
    toggleVisible() {
      this.$emit('toggle-visible');
    },
    toggleActive() {
      this.$emit('activate');
    },
    toggle3dView() {
      this.$emit('toggle-3d');
    },
    remove() {
      this.$emit('remove');
    },
    setStyle(styleId) {
      this.$emit('set-style', this.layer, styleId);
    },
    createStyle() {
      this.$emit('create-style');
    },
    zoomToTheLayersRange() {
      this.$emit('zoom-to-layer-range');
    },
    removeStyle(styleId) {
      this.$emit('remove-style', styleId);
    },
    enableGetFeatureInfo(layer) {
      this.$store.dispatch(SET_GET_FEATURE_INFO_LAYER, layer);
    },
    genereteRateRaport(layer) {
      this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'info',
        title: 'Informacja',
        message: 'Trwa generowanie raportu.',
        duration: 1000000
      });

      let api = new ApiStawki();

      api
        .getStawkiCsv({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId
        })
        .then(function(response) {
          let blob = new Blob([response.body], {
            type: 'application/csv'
          });

          var FileSaver = require('file-saver');
          FileSaver.saveAs(blob, 'stawki.csv');
        })
        .catch(function(e) {
          this.$store.commit(WINDOW_API_ERROR_SHOW, error);
        });
    }
  },
  watch: {
    'layer.createdStyleId': function(value) {
      this.setStyle(value);
    }
  }
};
</script>

<style>
.action {
  cursor: pointer;
  margin-left: 0.5rem;
}

.layer-expander {
  margin-left: 0;
}

.action.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.layer-item {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}

.layer-item .layer-name {
  overflow: hidden;
  word-wrap: break-word;
  width: 100%;
}

.layer-legend {
  padding-left: 3em;
}

.layer-legend img {
  display: block;
  margin: 0.5em 0;
}

.scrollable-menu {
  height: auto;
  max-height: 300px;
  overflow-x: hidden;
}

.layer-expander {
  padding: 0;
  margin-right: 0.5rem;
}

.scrollable-menu .remove-style {
  cursor: pointer;
}

.scrollable-menu .layer-style {
  cursor: default;
}
</style>
